<script setup>
import { Copy } from "lucide-vue-next";

const props = defineProps({
    value: { type: String, default: "" },
    copyKey: { type: String, required: true },
    copiedKey: { type: String, default: "" },
    copyToClipboard: { type: Function, required: true },
});

const onCopy = () => {
    props.copyToClipboard(props.value, props.copyKey);
};
</script>

<template>
    <button @click="onCopy"
        class="self-center flex-shrink-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-md border border-theme-border border-opacity-70 bg-white text-tiny font-semibold text-theme-secondary hover:bg-theme-bg-shade hover:bg-opacity-20 transition-colors">
        <Copy class="w-3 h-3 flex-shrink-0" />
        {{ copiedKey === copyKey ? 'Copied!' : 'Copy' }}
    </button>
</template>
